export const emptyBlocks = Array.from({ length: 4 }, () =>
  Array.from({ length: 10 })
);
